export const fetchSalesforceEnrichmentStart = (key) => {
  return {
    type: "FETCH_SALESFORCE_ENRICHMENT_STARTED",
    key
  }
}

export const fetchSalesforceEnrichmentFailed = (err, key) => {
  return {
    type: "FETCH_SALESFORCE_ENRICHMENT_FAILED",
    err,
    key
  }
}

export const fetchSalesforceEnrichmentSuccess = (data, key) => {
  return {
    type: "FETCH_SALESFORCE_ENRICHMENT_SUCCESS",
    data,
    key
  }
}
